export default __webpack_public_path__ + "static/media/bet-tnc-cn.5190b6a8.svg";